import { useMemo } from 'react'
import produce from 'immer'
import { useDataValue } from 'Simple/Data.js'
import { numberMoney } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let receivable = useDataValue({
    context: 'post_payment_info',
    path: 'receivable',
    viewPath: props.viewPath,
  })
  let patient_due_amount = useDataValue({
    context: 'post_payment_info',
    path: 'patient_due_amount',
    viewPath: props.viewPath,
  })
  let location_id = useDataValue({
    context: 'post_payment_info',
    path: 'treatment.organization._id',
    viewPath: props.viewPath,
  })
  let current_location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })
  let payer_account_id = useDataValue({
    context: 'message',
    path: 'params.payer_account_id',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    return produce(data, next => {
      // receivable balance has priority over payment account balance
      if (receivable) {
        next.amount = numberMoney(receivable.balance_amount || 0)
        next.receivable_id = receivable.id
        next.auto_apply_to_unpaid_receivables = false
      } else {
        next.amount = numberMoney(patient_due_amount || 0)
      }
      next.default_payment_account_id = receivable
        ? receivable.payment_account_id
        : payer_account_id
      next.location_id = location_id || current_location_id
    })
  }, [
    data,
    receivable,
    payer_account_id,
    patient_due_amount,
    location_id,
    current_location_id,
  ])
}
